export const FETCH_OFFICER = 'FETCH_OFFICER';
export const SAVE_OFFICER = 'SAVE_OFFICER';
export const CREATE_OFFICER = 'CREATE_OFFICER';
export const IS_LINKEDIN_CONNECTED = 'IS_LINKEDIN_CONNECTED';
export const CONNECT_LINKEDIN = 'CONNECT_LINKEDIN';
export const CONNECTED_LINKEDIN = 'CONNECTED_LINKEDIN';
export const LINKEDIN_DISCONNECTED = 'LINKEDIN_DISCONNECTED';
export const LINKEDIN_COULDNT_CONNECT = 'LINKEDIN_COULDNT_CONNECT';
export const IS_FACEBOOK_CONNECTED = 'IS_FACEBOOK_CONNECTED';
export const CONNECT_FACEBOOK = 'CONNECT_FACEBOOK';
export const FACEBOOK_DISCONNECTED = 'FACEBOOK_DISCONNECTED';
export const CONNECTED_FACEBOOK = 'CONNECTED_FACEBOOK';
export const FACEBOOK_COULDNT_CONNECT = 'FACEBOOK_COULDNT_CONNECT';
export const IS_GOOGLE_CONNECTED = 'IS_GOOGLE_CONNECTED';
export const CONNECT_GOOGLE = 'CONNECT_GOOGLE';
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const GOOGLE_DISCONNECTED = 'GOOGLE_DISCONNECTED';
export const CONNECTED_GOOGLE = 'CONNECTED_GOOGLE';
export const GOOGLE_COULDNT_CONNECT = 'GOOGLE_COULDNT_CONNECT';
export const MARK_OFFICER_INACTIVE = 'MARK_OFFICER_INACTIVE';
export const UPLOAD_AVATAR = 'UPLOAD_AVATAR';
export const LOGIN = 'LOGIN';
export const SHOW_LOGIN = 'SHOW_LOGIN';
export const GET_OFFICER_REVIEW = 'GET_OFFICER_REVIEW';
export const SAVE_REVIEW_REPLY = 'SAVE_REVIEW_REPLY';
export const UN_PUBLISH_REVIEW = 'UN_PUBLISH_REVIEW';
export const LOGOUT = 'LOGOUT';
export const FORGOT_PASSWORD = 'FORGOTPASSWORD';
export const FETCH_LENDER_OFFICERS = 'FETCH_LENDER_OFFICERS';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const FETCHING = 'FETCHING';
